import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EMRService } from '../EMR.service';
import { DashboardService } from 'app/dashboard/dashboard.service';

@Component({
  selector: 'app-Diabetic_Survey',
  templateUrl: './Diabetic_Survey.component.html',
  styleUrls: ['./Diabetic_Survey.component.scss']
})
export class Diabetic_SurveyComponent implements OnInit {

  constructor(public dialog: MatDialog,
    public emrservice: EMRService,
    public dashboardService: DashboardService) { }

  ngOnInit() {
   this.emrservice.diabetic_survey={};
   this.getdiabetic();
  }

  getdiabetic(){
  this.emrservice.getdoctor_survey().subscribe((item:any)=>{
    this.emrservice.diabetic_survey=item;
  },err=>{
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  });
  }
  closedialog(){
    this.dialog.closeAll();
  }
  
  savesurvey(){
    // call api to save data
    this.dashboardService.subscriptions= this.emrservice.save_diabetic_survey().subscribe(
      data => this.success_survey(data), err=> this.failed_survey(err)
    )
    //show confirmation box
    // close dialog
    
  }

  success_survey(data){
this.dashboardService.openSnackBar("Diabetic survey saved successfully", "OK");
this.getdiabetic();
this.dialog.closeAll();

  }
  failed_survey(err){
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
}
